import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS, ROLE, NOTIFICATION_INTERVAL, WORKOUT_PLAN, WORKOUT_CATEGORY, MEDICINE_OPTIONS } from '../../../../utils/Constants'
import { handleServerValidations, capitalizeFirstLetter } from '../../../../utils/commonfunction'
import { createPrescription, getPrescription, updatePrescription } from '../../services/patient.services'
import { getAllMedicine } from '../../../admin/services/medicine.services'
import * as Yup from 'yup';
import { param } from 'jquery'
import { DatePicker, TagPicker, Tooltip, Whisper } from 'rsuite'
import ChiefComplaintInput from '../../../../utils/ChiefComplaintInput'
import MedicineSelect from '../../../../utils/MedicineSelect.js'

export default function PrescriptionEdit() {
    const { t } = useTranslation()
    const [defaultData, setDefaultData] = useState({});
    const fileSelectInput = useRef();
    const [loader, setLoader] = useState(true);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const location = useLocation();
    const [medicineData, setMedicineData] = useState([]);
    const navigate = useNavigate();
    const [prescriptionData, setPrescriptionData] = useState({});
    const params = useParams();

    const prescriptionValidationSchema = Yup.object().shape({
        // symptoms: Yup.string().trim().required('Chief complaint is required'),
        // diagnosis_notes: Yup.string().trim().required('Diagnosis is required'),
        // past_medical_history: Yup.string().trim().required('Past medical history is required'),
        // investigation_advise: Yup.string().trim().required('Investigation advice is required'),
        // follow_up_date: Yup.date().required('Follow up date is required'),
        // test_name: Yup.string().trim().required('Laboratory test is required'),
        medications: Yup.array().of(
            Yup.object().shape({
                medicine_id: Yup.string().required('Medicine selection is required'),
                dosage: Yup.string().required('Dosage is required'),
                notification_times: Yup.array()
                    .of(Yup.string().required('Frequency is required'))
                    .min(1, 'At least one frequency is required'),
                // start_date: Yup.date().required('Start date is required'),
                end_date: Yup.date().required('End date is required'),
                meal_time: Yup.string().required('Medicine instruction is required'),
                remarks: Yup.string().trim().required('Remarks note is required'),
            })
        ),
        // exercises: Yup.array().of(
        //     Yup.object().shape({
        //         workout_category: Yup.string().required('Workout category is required'),
        //         workout_time: Yup.string().required('workout time is required'),
        //         workout_duration: Yup.string().required('Workout duration is required'),
        //         workout_plan: Yup.string().required('Workout plan is required'),
        //     })
        // ),
    });

    const addMedication = () => {
        editForm.setFieldValue("medications", [
            ...editForm.values.medications,
            { medicine_id: "", dosage: "", notification_times: [], start_date: "", end_date: "", meal_time: "", remarks: "" }
            // { medicine_id: "", dosage: "", frequency: "", start_date: "", end_date: "", meal_time: "" }
        ])
    };

    const removeMedication = (idx) => {
        const updatedMedications = editForm.values.medications.filter((med, index) => index !== idx);
        editForm.setFieldValue("medications", updatedMedications);
    };

    const addExercise = () => {
        editForm.setFieldValue("exercises", [
            ...editForm.values.exercises,
            { workout_category: "", workout_time: "", workout_duration: "", workout_plan: "" }
        ])
    };

    const removeExercise = (idx) => {
        const updatedExercises = editForm.values.exercises.filter((med, index) => index !== idx);
        editForm.setFieldValue("exercises", updatedExercises);
    };

    useEffect(() => {
        getPrescription({ appointment_id: params?.id })
            .then((response) => {
                let medicines = response?.data?.medicines;
                medicines = medicines.map(medicine => {

                    const start_date = new Date(medicine.start_date);
                    let year = start_date.getFullYear();
                    let month = String(start_date.getMonth() + 1).padStart(2, "0");
                    let date = String(start_date.getDate()).padStart(2, "0");
                    const formattedStartDate = `${year}-${month}-${date}`;

                    const end_date = new Date(medicine.end_date);
                    year = end_date.getFullYear();
                    month = String(end_date.getMonth() + 1).padStart(2, "0");
                    date = String(end_date.getDate()).padStart(2, "0");
                    const formattedEndDate = `${year}-${month}-${date}`;

                    if (!medicine.medicine_id) {
                        return {
                            ...medicine,
                            medicine_id: 'other',
                            medicine_name : medicine.medicine.name,
                            start_date: formattedStartDate,
                            end_date: formattedEndDate
                        }
                    }
                    return {
                        ...medicine,
                        start_date: formattedStartDate,
                        end_date: formattedEndDate
                    }
                })
                response.data.medicines = medicines;
                setPrescriptionData(response?.data);

            })
            .catch((err) => {
                console.log(err);
            });
    }, [])

    const editForm = useFormik({
        initialValues: {
            patient_id: "",
            symptoms: prescriptionData?.symptoms?.map((item) => item._id) || [],
            diagnosis_notes: prescriptionData?.diagnosis_notes || "",
            past_medical_history: prescriptionData?.past_medical_history || "",
            // investigation_advise: prescriptionData?.investigation_advise || "",
            follow_up_date: prescriptionData?.follow_up_date || "",
            test_name: prescriptionData?.test_name || "",
            medicine_note: prescriptionData?.medicine_note || "",
            medications: prescriptionData?.medicines?.length > 0
                ? prescriptionData.medicines
                : [{ medicine_id: "", dosage: "", notification_times: [], start_date: "", end_date: "", meal_time: "", remarks: "" }],
            // : [{ medicine_id: "", dosage: "", frequency: "", start_date: "", end_date: "", meal_time: "" }],
            exercises: prescriptionData?.exercises?.length > 0
                ? prescriptionData.exercises
                : [{ workout_category: "", workout_time: "", workout_duration: "", workout_plan: "" }],
        },
        validationSchema: prescriptionValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            console.log(values?.medications, '========medincines');
            values.medications = values.medications?.map(medicine =>{
                medicine.start_date = new Date(medicine.start_date);
                medicine.start_date.setHours(0, 0, 0, 0);
                medicine.end_date = new Date(medicine.end_date);
                medicine.end_date.setHours(23, 59, 59, 999);
                return medicine;
            })

            values.exercises = values.exercises?.filter(exercise => exercise.workout_category) || [];

            const formData = new FormData();
            formData.append("history_id", prescriptionData?._id);
            formData.append("symptoms", JSON.stringify(values.symptoms));
            formData.append("diagnosis_notes", values.diagnosis_notes);
            formData.append("past_medical_history", values.past_medical_history);
            // formData.append("investigation_advise", values.investigation_advise);
            formData.append("follow_up_date", values.follow_up_date);
            formData.append("test_name", values.test_name);
            formData.append("medicine_note", values.medicine_note);
            formData.append("medicines", JSON.stringify(values.medications));
            formData.append("exercises", JSON.stringify(values.exercises));
            setAddSubmissionLoader(true);
            updatePrescription(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        navigate(`/doctor/consultation-history/1`)
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating Prescription", error);
                });
        },
    });

    useEffect(() => {
        getAllMedicine(ROLE.DOCTOR)
            .then((data) => {
                if (data && data.data) {
                    setMedicineData(data?.data || []);
                }
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, [])

    const getDateWithTimeNew = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(Number(hours), Number(minutes), 0, 0);
        return date;
    };

    return (
        <main id='main-content'>
            <div className='inner-container'>

                {/* {loader ?
                               <div className='w-100'>
                                   <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                                   <Skeleton className='mt-4' style={{ height: "30px" }} />
                                   <Skeleton className='mt-4' style={{ height: "30px" }} />
                                   <Skeleton className='mt-4' style={{ height: "30px" }} />
                               </div>
                               : */}
                <form onSubmit={editForm.handleSubmit}>
                    {/* Personal Info Section */}
                    <div className='card'>
                        <div className='card-body'>
                            <div className="mb-3 card-info">
                                <h3>Personal Info</h3>
                                <p className="mb-1">#{location.state.data?.patient_register_id}</p>
                                <h4>{capitalizeFirstLetter(location.state.data?.patient_name)}</h4>
                            </div>
                            <div className='card-info-action'>
                                <button className="btn btn-primary mt-2"
                                    onClick={() => {
                                        navigate(`/doctor/consultation-history/view/${location.state.data?._id}`)
                                    }}>
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='card mt-4'>
                        <div className='card-body'>
                            {/* Symptoms Section */}
                            {/* <div className="mb-3">
                                <label className="form-label">
                                    {t("Chief Complaint")}
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Enter chief complaint")}
                                    name="symptoms"
                                    value={editForm.values.symptoms}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.symptoms && editForm.errors.symptoms && (
                                    <div className="text-danger">{editForm.errors.symptoms}</div>
                                )}
                            </div> */}
                            <ChiefComplaintInput Form={editForm} />

                            <div className="mb-3">
                                <label className="form-label">
                                    {t("Past Medical History")}
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Enter past medical history")}
                                    name="past_medical_history"
                                    value={editForm.values.past_medical_history}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.past_medical_history && editForm.errors.past_medical_history && (
                                    <div className="text-danger">{editForm.errors.past_medical_history}</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Diagnosis</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter diagnosis"
                                    name="diagnosis_notes"
                                    value={editForm.values.diagnosis_notes}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.diagnosis_notes && editForm.errors.diagnosis_notes && (
                                    <div className="text-danger">{editForm.errors.diagnosis_notes}</div>
                                )}
                            </div>
                            {/* <div className="mb-3">
                                <label className="form-label">Investigation Advise</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter investigation advise"
                                    name="investigation_advise"
                                    value={editForm.values.investigation_advise}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.investigation_advise && editForm.errors.investigation_advise && (
                                    <div className="text-danger">{editForm.errors.investigation_advise}</div>
                                )}
                            </div> */}
                            <div className='add-more-medication-wrap'>
                                {/* Medications Section */}
                                {editForm?.values?.medications?.map((med, index) => (
                                    <div className='' key={med.id || index}>
                                        <div className="row add-more-medication-row">

                                            {/* Medicine Name */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Medicine")}</label>
                                                <select
                                                    className="form-control cp"
                                                    name={`medications[${index}].medicine_id`}
                                                    value={med.medicine_id}
                                                    onChange={editForm.handleChange}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="other">{t("Other")}</option>
                                                    {medicineData?.map((item) => (
                                                        <option key={item._id} value={item._id}>
                                                            {capitalizeFirstLetter(item.name)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {editForm.touched.medications?.[index]?.medicine_id && editForm.errors.medications?.[index]?.medicine_id && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].medicine_id)}</div>
                                                )}
                                            </div> */}

                                            <MedicineSelect form={editForm} index={index} medicineData={medicineData} />

                                            {/* Dosage */}
                                            <div className="col-md-1 add-more-medication-item">
                                                <label htmlFor="dosage" className="form-label">{t("Dosage")}</label>
                                                <input
                                                    className="form-control"
                                                    name={`medications[${index}].dosage`}
                                                    placeholder="Dosage"
                                                    value={med.dosage}
                                                    onChange={editForm.handleChange}
                                                />
                                                {editForm.touched.medications?.[index]?.dosage && editForm.errors.medications?.[index]?.dosage && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].dosage)}</div>
                                                )}
                                            </div>

                                            {/* Notification Interval (Hours) Dropdown */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Frequency")}</label>
                                                <TagPicker
                                                    data={NOTIFICATION_INTERVAL}
                                                    className="form-control-tag-picker"
                                                    onChange={(e) => editForm.setFieldValue(`medications[${index}].notification_times`, e)}
                                                    cleanable={false}
                                                    value={Array.isArray(editForm.values.medications?.[index]?.notification_times)
                                                        ? editForm.values.medications[index].notification_times
                                                        : []}
                                                />
                                                {editForm.touched.medications?.[index]?.notification_times &&
                                                    editForm.errors.medications?.[index]?.notification_times && (
                                                        <div className="text-danger">{t(editForm.errors.medications[index].notification_times)}</div>
                                                    )}
                                            </div> */}

                                            <div className="col-md-2 add-more-medication-item">
                                            <label className="form-label">{t("Frequency")}</label>
                                            <Whisper
                                                placement="top"
                                                trigger={
                                                Array.isArray(editForm.values.medications?.[index]?.notification_times) &&
                                                editForm.values.medications[index].notification_times.length > 0
                                                    ? "hover"
                                                    : "none"
                                                }
                                                speaker={
                                                <Tooltip>
                                                    {Array.isArray(editForm.values.medications?.[index]?.notification_times)
                                                    ? editForm.values.medications[index].notification_times.join(', ')
                                                    : "No times selected"}
                                                </Tooltip>
                                                }
                                            >
                                                <div className="tagpicker-wrapper">
                                                <TagPicker
                                                    data={NOTIFICATION_INTERVAL}
                                                    className="form-control-tag-picker custom-tag-picker"
                                                    onChange={(e) =>
                                                    editForm.setFieldValue(`medications[${index}].notification_times`, e)
                                                    }
                                                    cleanable={false}
                                                    value={
                                                    Array.isArray(editForm.values.medications?.[index]?.notification_times)
                                                        ? editForm.values.medications[index].notification_times
                                                        : []
                                                    }
                                                    renderValue={(selected, selectedItems) => {
                                                    if (!selectedItems || selectedItems.length === 0) return '';
                                                    const displayCount = 2; // Always show 2 items
                                                    const displayItems = selectedItems
                                                        .slice(0, displayCount)
                                                        .map((item) => item.label || item.value);
                                                    const remainingCount = selectedItems.length - displayCount;

                                                    return `${displayItems.join(', ')}${
                                                        remainingCount > 0 ? `, +${remainingCount} more` : ''
                                                    }`;
                                                    }}
                                                />
                                                </div>
                                            </Whisper>

                                            {editForm.touched.medications?.[index]?.notification_times &&
                                                editForm.errors.medications?.[index]?.notification_times && (
                                                <div className="text-danger">
                                                    {t(editForm.errors.medications[index].notification_times)}
                                                </div>
                                                )}
                                            </div>

                                            {/* Frequency */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Frequency")}</label>
                                                <input
                                                    className="form-control"
                                                    name={`medications[${index}].frequency`}
                                                    placeholder="Frequency"
                                                    value={med.frequency}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        editForm.setFieldValue(`medications[${index}].frequency`, value);
                                                    }}
                                                />
                                                {editForm.touched.medications?.[index]?.frequency && editForm.errors.medications?.[index]?.frequency && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].frequency)}</div>
                                                )}
                                            </div> */}

                                            {/* Start Date */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Start Date")}</label>
                                                <DatePicker oneTap={true} classPrefix="restaurant" placeholder={t("Enter start date")} placement="autoVertical" format="dd.MM.yyyy" cleanable={false}
                                                    name={`medications[${index}].start_date`}
                                                    onChange={(e) => {
                                                        // if (e) {
                                                        //     // Set to START of the selected day (local 00:00:00.000)
                                                        //     e.setHours(0, 0, 0, 0);
                                                        // }
                                                        // console.log(e, '=======start date')

                                                        const year = e.getFullYear();
                                                        const month = String(e.getMonth() + 1).padStart(2, "0");
                                                        const date = String(e.getDate()).padStart(2, "0");
                                                        const formattedDate = `${year}-${month}-${date}`;
                                                        
                                                        editForm.setFieldTouched(`medications[${index}].start_date`, true);
                                                        editForm.setFieldValue(`medications[${index}].start_date`, formattedDate);
                                                    }}
                                                    value={new Date(med.start_date)}
                                                // onBlur={editForm.handleBlur}
                                                // shouldDisableDate={(date) => {
                                                //     const today = new Date();
                                                //     today.setHours(0, 0, 0, 0);
                                                //     return date >= today;
                                                // }} 
                                                />
                                                {editForm.touched.medications?.[index]?.start_date && editForm.errors.medications?.[index]?.start_date && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].start_date)}</div>
                                                )}
                                            </div> */}

                                            <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("End Date")}</label>
                                                <DatePicker oneTap={true} classPrefix="restaurant" placeholder={t("Enter end date")} placement="autoVertical" format="dd.MM.yyyy"
                                                    cleanable={false} name={`medications[${index}].end_date`} onChange={(e) => {
                                                        // if (e) {
                                                        //     // Set to END of the selected day (local 23:59:59.999)
                                                        //     e.setHours(23, 59, 59, 999);
                                                        // }
                                                        // console.log(e, '=======end date')
                                                        const year = e.getFullYear();
                                                        const month = String(e.getMonth() + 1).padStart(2, "0");
                                                        const date = String(e.getDate()).padStart(2, "0");
                                                        const formattedDate = `${year}-${month}-${date}`;

                                                        editForm.setFieldTouched(`medications[${index}].end_date`, true);
                                                        editForm.setFieldValue(`medications[${index}].end_date`, formattedDate);
                                                    }} value={new Date(med.end_date)}
                                                // onBlur={editForm.handleBlur}
                                                // shouldDisableDate={(date) => {
                                                //     const today = new Date();
                                                //     today.setHours(0, 0, 0, 0);
                                                //     return date >= today;
                                                // }} 
                                                />
                                                {editForm.touched.medications?.[index]?.end_date && editForm.errors.medications?.[index]?.end_date && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].end_date)}</div>
                                                )}
                                            </div>

                                            {console.log(new Date(), '==============current Date')}

                                            {/* <div className="col-md-3 add-more-medication-item mt-2">
                                                <label className="form-label">{t("Choose Option")}</label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id={`beforeMeal-${index}`}
                                                            name={`medications[${index}].meal_time`} // Same name for both options
                                                            checked={med.meal_time === "before"} // Check if the value is "before"
                                                            onChange={() => {
                                                                editForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                                editForm.setFieldValue(`medications[${index}].meal_time`, "before");
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`beforeMeal-${index}`}>
                                                            {t("Before Meal")}
                                                        </label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id={`afterMeal-${index}`}
                                                            name={`medications[${index}].meal_time`} // Same name for both options
                                                            checked={med.meal_time === "after"} // Check if the value is "after"
                                                            onChange={() => {
                                                                editForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                                editForm.setFieldValue(`medications[${index}].meal_time`, "after");
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`afterMeal-${index}`}>
                                                            {t("After Meal")}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Choose Option")}</label>
                                                <select
                                                    className="form-control"
                                                    name={`medications[${index}].meal_time`}
                                                    value={med.meal_time || ""}
                                                    onChange={(e) => {
                                                        editForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                        editForm.setFieldValue(`medications[${index}].meal_time`, e.target.value);
                                                    }}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {
                                                        MEDICINE_OPTIONS.map(option=>
                                                            <option value={option.value}>{option.label}</option>
                                                        )
                                                    }
                                                    {/* <option value="before">{t("Before Meal")}</option>
                                                    <option value="after">{t("After Meal")}</option> */}
                                                </select>
                                                {editForm.touched.medications?.[index]?.meal_time && editForm.errors.medications?.[index]?.meal_time && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].meal_time)}</div>
                                                )}
                                            </div>

                                            {/* Remarks */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">Remarks</label>
                                                <input
                                                    type="text"
                                                    name={`medications[${index}].remarks`}
                                                    value={med.remarks}
                                                    onChange={(e) => {
                                                        editForm.setFieldTouched(`medications[${index}].remarks`, true);
                                                        editForm.setFieldValue(`medications[${index}].remarks`, e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Remarks"
                                                    id={`medications[${index}].remarks`}
                                                />
                                                {editForm.touched.medications?.[index]?.remarks && editForm.errors.medications?.[index]?.remarks && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].remarks)}</div>
                                                )}
                                            </div>    

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div>
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div> */}

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">{t("Interval(Hours)")}</label>
                                                <select
                                                    className="form-control cp"
                                                    name={`medications[${index}].notification_interval`}
                                                    value={med.notification_interval}
                                                    onChange={editForm.handleChange}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {NOTIFICATION_INTERVAL?.map((item) => (
                                                        <option key={item} value={item}>
                                                            {item}
                                                        </option>
                                                    ))}
                                                </select>
                                                {editForm.touched.medications?.[index]?.notification_interval && editForm.errors.medications?.[index]?.notification_interval && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].notification_interval)}</div>
                                                )}
                                            </div> */}

                                            {med.medicine_id === "other" && (
                                                <div className="mt-3">
                                                    <input
                                                        className="form-control"
                                                        name={`medications[${index}].medicine_name`}
                                                        placeholder={t("Enter custom medicine name")}
                                                        value={med.medicine_id === "other" ? med.medicine_name || "" : ""}
                                                        onChange={e => {
                                                            editForm.setFieldValue(`medications[${index}].medicine_name`, e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            {/* {Number(med.frequency) > 0 &&
                                                Array.from({ length: Number(med.frequency) }).map((_, inputIndex) => (
                                                    <div key={inputIndex} className="col-md-3 add-more-medication-item mt-2">
                                                        <label className="form-label">
                                                            {t(`Dosage ${inputIndex + 1} (Time)`)}
                                                        </label>
                                                        <DatePicker
                                                            classPrefix="restaurant"
                                                            placement="autoVertical"
                                                            format="HH:mm"
                                                            cleanable={false}
                                                            editable={true}
                                                            name={`medications[${index}].notification_times[${inputIndex}]`}
                                                            value={
                                                                med.notification_times?.[inputIndex]
                                                                    ? getDateWithTimeNew(med.notification_times[inputIndex])
                                                                    : null
                                                            }
                                                            onChange={(value) => {
                                                                const formattedTime = value ? value.toTimeString().slice(0, 5) : '';
                                                                const updatedTimes = [...(med.notification_times || [])];
                                                                updatedTimes[inputIndex] = formattedTime;
                                                                editForm.setFieldValue(`medications[${index}].notification_times`, updatedTimes);
                                                            }}
                                                            onBlur={editForm.handleBlur}
                                                        />
                                                    </div>
                                                ))} */}

                                            {/* <div className="col-md-12 add-more-medication-item mt-3">
                                                <label className="form-label">Medicine Note</label>
                                                <textarea
                                                    rows={2}
                                                    className="form-control"
                                                    name={`medications[${index}].medicine_note`}
                                                    placeholder="Medicine Note"
                                                    value={med.medicine_note}
                                                    onChange={editForm.handleChange}
                                                />
                                                {editForm.touched.medications?.[index]?.medicine_note && editForm.errors.medications?.[index]?.medicine_note && (
                                                    <div className="text-danger">{t(editForm.errors.medications[index].medicine_note)}</div>
                                                )}
                                            </div> */}

                                            {editForm?.values?.medications?.length > 1 && (
                                                <button type="button" className="btn btn-secondary mt-4" onClick={() => removeMedication(index)}>
                                                    ✖
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className='add-more-medication-wrap mt-3'>
                                <button type="button" className="link-text text-start bg-white" style={{ width: 'fit-content' }} onClick={addMedication}>
                                    + Add More
                                </button>
                            </div>
                             <div className="mb-3 mt-3">
                                <label className="form-label">Medicine Note
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter medicine note"
                                    name="medicine_note"
                                    value={editForm.values.medicine_note}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.medicine_note && editForm.errors.medicine_note && (
                                    <div className="text-danger">{editForm.errors.medicine_note}</div>
                                )}
                            </div>
                            <div className='add-more-medication-wrap mt-4'>
                                {/* Exercise Section */}
                                {editForm?.values?.exercises?.map((exe, index) => (
                                    <div className='' key={exe.id || index}>
                                        <div className="row add-more-medication-row">
                                            {/* Workout Category */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">{t("Workout Category")}</label>
                                                <select
                                                    className="form-control cp"
                                                    name={`exercises[${index}].workout_category`}
                                                    value={exe.workout_category}
                                                    onChange={editForm.handleChange}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {WORKOUT_CATEGORY.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {capitalizeFirstLetter(item.label)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {editForm.touched.exercises?.[index]?.workout_category && editForm.errors.exercises?.[index]?.workout_category && (
                                                    <div className="text-danger">{t(editForm.errors.exercises[index].workout_category)}</div>
                                                )}
                                            </div>
                                            {/* Workout Time */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Workout Time")}
                                                </label>
                                                <DatePicker
                                                    classPrefix="restaurant"
                                                    placement="autoVertical"
                                                    format="HH:mm"
                                                    cleanable={false}
                                                    editable={true}
                                                    name={`exercises[${index}].workout_time`}
                                                    // value={exe.workout_time ? new Date(exe.workout_time) : null}
                                                    value={
                                                        exe.workout_time
                                                            ? new Date(`1970-01-01T${exe.workout_time}:00`)
                                                            : null
                                                    }
                                                    // onChange={(value) =>
                                                    //     editForm.setFieldValue(`exercises[${index}].workout_time`, value)
                                                    // }
                                                    onChange={(value) => {
                                                        const timeOnly = value ? value.toTimeString().slice(0, 5) : null; // "HH:mm"
                                                        editForm.setFieldValue(`exercises[${index}].workout_time`, timeOnly);
                                                    }}
                                                    onBlur={editForm.handleBlur}
                                                    hideMinutes={(minute) => minute % 15 !== 0}
                                                />
                                                {editForm.touched.exercises?.[index]?.workout_time && editForm.errors.exercises?.[index]?.workout_time && (
                                                    <div className="text-danger">{t(editForm.errors.exercises[index].workout_time)}</div>
                                                )}
                                            </div>
                                            {/* Workout Duration */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label htmlFor="workout_duration" className="form-label">{t("Workout Duration(Minutes)")}</label>
                                                <input
                                                    className="form-control"
                                                    name={`exercises[${index}].workout_duration`}
                                                    placeholder="Workout duration"
                                                    value={exe.workout_duration}
                                                    onChange={editForm.handleChange}
                                                />
                                                {editForm.touched.exercises?.[index]?.workout_duration && editForm.errors.exercises?.[index]?.workout_duration && (
                                                    <div className="text-danger">{t(editForm.errors.exercises[index].workout_duration)}</div>
                                                )}
                                            </div>
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">{t("Workout Plan")}</label>
                                                <select
                                                    className="form-control cp"
                                                    name={`exercises[${index}].workout_plan`}
                                                    value={exe.workout_plan}
                                                    onChange={editForm.handleChange}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {WORKOUT_PLAN.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {capitalizeFirstLetter(item.label)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {editForm.touched.exercises?.[index]?.workout_plan && editForm.errors.exercises?.[index]?.workout_plan && (
                                                    <div className="text-danger">{t(editForm.errors.exercises[index].workout_plan)}</div>
                                                )}
                                            </div>
                                            {editForm?.values?.exercises?.length > 1 && (
                                                <button type="button" className="btn btn-secondary mt-4" onClick={() => removeExercise(index)}>
                                                    ✖
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className='add-more-medication-wrap mt-3'>
                                <button type="button" className="link-text text-start bg-white" onClick={addExercise}>
                                    + Add More
                                </button>
                            </div>
                            <div className="mb-3 mt-4">
                                <label className="form-label" style={{ color: "#212121", fontWeight: 800 }}>
                                    {t("Follow-up Date")}

                                </label>
                                <DatePicker
                                    oneTap={true}
                                    classPrefix="restaurant"
                                    placeholder={t("Enter follow up date")}
                                    placement="autoVertical"
                                    format="dd.MM.yyyy"
                                    cleanable={false}
                                    name="follow_up_date"
                                    onChange={(e) => {
                                        editForm.setFieldTouched('follow_up_date', true);
                                        editForm.setFieldValue("follow_up_date", e?.toISOString());
                                    }}
                                    value={editForm.values.follow_up_date ? new Date(editForm.values.follow_up_date) : null}
                                    onBlur={editForm.handleBlur}
                                />

                                {editForm.touched.follow_up_date && editForm.errors.follow_up_date && (
                                    <div className="text-danger">{editForm.errors.follow_up_date}</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label className="form-label" style={{ color: "#212121", fontWeight: 800 }}>Diagnosis Test</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter laboratory test"
                                    name="test_name"
                                    value={editForm.values.test_name}
                                    onChange={editForm.handleChange}
                                    onBlur={editForm.handleBlur}
                                ></textarea>
                                {editForm.touched.test_name && editForm.errors.test_name && (
                                    <div className="text-danger">{editForm.errors.test_name}</div>
                                )}
                                {/* </div>
                        </div> */}
                            </div>
                            <div className="d-flex justify-content-start gap-2 mt-4">
                                {/* <button type="submit" className={`btn btn-secondary${addSubmissionLoader ? ' btn-loader' : ''}`}>
                                           Cancel
                                       </button> */}
                                <button type="submit" className={`btn btn-primary${addSubmissionLoader ? ' btn-loader' : ''}`}>
                                    Update
                                </button>
                            </div>
                            {/* <div className='card mt-4'>
                        <div className='card-body'> */}
                        </div>
                    </div>
                </form>
                {/* } */}


            </div>
        </main>
    )
}
